import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './News.scss';
import groupBy from 'lodash.groupby';
import toPairs from 'lodash.topairs';
import cn from 'classnames';
import Sticky from 'react-sticky-el';
import { connect } from 'react-redux';
import { setPopUp } from 'actions/environment';
import { allNews } from 'actions/news';
import { formatDate, formatTime } from 'utils';
import { ROOT_URL } from 'constants/Config';
import { withTranslation } from 'react-i18next';

class News extends Component {

  handleLinkClick = (e) => {
    e.stopPropagation();
  };
  handlePopupLinkClick = () => {
    this.props.setPopUp(undefined);
  };

  handleMoreClick = (item) => {
    this.props.setPopUp(
      <div className={styles.NewsPopupWrap}>
        <div className={styles.PopupTitle}>
          {
            item.building.image ?
              <Link
                to={`/building/${item.building.id}`}
                onClick={this.handlePopupLinkClick.bind(this)}
              >
                <img
                  src={
                      `${ROOT_URL}/image?id=${item.building.image.id}&size=small`
                    }
                  className={styles.PopupTitleImg}
                  alt=""
                />
              </Link>
                : null
          }
          <span>
            <Link
              to={`/building/${item.building.id}`}
              onClick={this.handlePopupLinkClick.bind(this)}
            >
              {item.building.name}
            </Link>
          </span>
        </div>
        <div className={cn(styles.PopupNewsList, 'custom-scrollbar')}>
          <div className={styles.PopupNewsItem}>
            <time className={styles.PopupNewsItemDate}>{formatDate(item.dateUpdate)}, {formatTime(item.dateUpdate)}</time>
            <p className={styles.PopupNewsItemText}>
              { item.name }
            </p>
          </div>
        </div>
      </div>,
      {
        className: styles.NewsPopup,
        contentClassName: styles.NewsPopupContent,
        closeStyleName: 'Default',
        closeClassName: styles.NewsPopupClose,
        contentStyleName: 'Default',
        closeIcon: 'default'
      }
    );
  }

  UNSAFE_componentWillMount() {
    this.props.allNews({ limit: 20, offset: 0 });
  }

  componentDidMount = () => {
    this.ref.addEventListener('scroll', this.handleScroll);
  }

  newsDidMount = (ref) => {
    this.ref = ref;
  }

  componentWillUnmount = () => {
    this.ref.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = (e) => {
    // console.log('scroll news', e.currentTarget.scrollHeight, e.currentTarget.scrollTop)
    if (
      e.currentTarget.scrollHeight > e.currentTarget.scrollWidth ? (
        e.currentTarget.scrollHeight - e.currentTarget.scrollTop - e.currentTarget.clientHeight < 200
      ) : (
        e.currentTarget.scrollWidth - e.currentTarget.scrollLeft - e.currentTarget.clientWidth < 200
      ) && !this.props.loading && !this.props.finished
    ) {
      this.props.allNews({ limit: 20, offset: this.props.offset });
    }
  }

  render() {
    const { data, t } = this.props;
    const groupedData = (data && data.length) ?
    toPairs(
        groupBy(
            data,
            ({ dateUpdate }) => dateUpdate.split(' ')[0]
        )
    )
    .sort((a, b) => a[0] < b[0] ? 1 : -1) : [];

    const items = groupedData.map(
        ([date, array]) => [
          <Sticky scrollElement=".scrollarea" stickyClassName={styles.stickyEl} className={styles.NewsFeedItemDate}>
            {formatDate(date)}
          </Sticky>,
          // <div className={styles.NewsFeedItemDate}>
          //   {formatDate(date)}
          // </div>,
          array
          .map(
            (item) => (
              <div
                className={cn(styles.NewsFeedItem, { [styles.Marked]: false })}
                onClick={() => this.handleMoreClick(item)}
              >
                <Link
                  to={`/building/${item.building.id}`}
                  className={styles.NewsLink}
                  onClick={this.handleLinkClick}
                >
                  <div className={styles.NewsHeader}>
                    {
                        item.building.image &&
                        <img
                          src={
                              `${ROOT_URL}/image?id=${item.building.image.id}&size=small`
                            }
                          className={styles.NewsHeaderImg}
                          alt=""
                        />
                      }
                    <div className={styles.NewsHeaderRight}>
                      <p className={styles.ObjectName}>{item.building.name}</p>
                      <time className={styles.NewsTime}>
                        {formatDate(item.dateUpdate)}, {formatTime(item.dateUpdate)}
                      </time>
                    </div>
                  </div>
                </Link>
                <div className={styles.NewsText}>
                  { item.name.length > 100 ? `${item.name.slice(0, 100)}…` : item.name}
                </div>
                {
                    item.name.length > 100 ?
                      <span className={styles.ReadMore}>
                        {t('components.buildings.news.readMore')}
                      </span> : null
                  }
              </div>
            )
        )
        ]
    );

    return (
      <div className={styles.NewsFeedWrap}>
        <div className={styles.NewsFeed}>
          <p className={styles.NewsFeedTitle}>
            {t('components.buildings.news.title')}
          </p>
          <div className={cn(styles.scrollArea, 'scrollarea', 'custom-scrollbar')} ref={this.newsDidMount}>
            {items}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(
  connect(
    state => state.allNews,
    { setPopUp, allNews }
  )(News)
);



// WEBPACK FOOTER //
// ./src/components/Buildings/News/News.js